import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { isCompleteGraphQLConfig } from "../util/config.js";
import { getHealthCheck } from "../util/health.js";
const serviceProvider = {
    name: 'yelp',
    title: 'Yelp',
    description: 'Yelp publishes crowd-sourced businesses reviews.',
    categories: ['reviews'],
    links: [
        {
            title: 'Homepage',
            url: 'https://www.yelp.com/developers/graphql/guides/intro'
        }
    ],
    serviceType: 'graphql',
    introspectionType: 'graphql',
    createId: value('yelp'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9A-Za-z_-]+',
                default: 'yelp'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: 'Yelp'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'Yelp'
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    token: {
                        title: 'API Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        },
        required: ['title', 'id', 'namespace', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'Human-readable identifier for use in the UI.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A pascal-case prefix that will be added to types in your GraphCMS API.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'Unique identifier for use in the API and Schema.'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? 'Yelp',
            namespace: formData.namespace ?? 'Yelp',
            provider: 'yelp',
            serviceType: 'graphql',
            authenticationType: 'bearer',
            options: {
                endpoint: 'https://api.yelp.com/v3/graphql'
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    isCompleteConfig: isCompleteGraphQLConfig,
    getHealthCheck: getHealthCheck({ checkName: 'graphqlIntrospection' })
};
export default serviceProvider;
